/**
 * Convert a subtype of identifier into an identifier alone.
 *
 * @param  {ResourceIdentifier} target - an instance of a subtype of identifier
 * @return {ResourceIdentifier} an identifier (not a subtype thereof)
 */
export function resourceIdentifier(target) {
    const { id, meta = undefined, type } = target;
    return { id, ...(meta ? { meta } : {}), type };
}
/**
 * Convert a subtype of identifier into an identifier alone.
 *
 * @param  {JsonapiIdentifier} target - an instance of a subtype of identifier
 * @return {JsonapiIdentifier} an identifier (not a subtype thereof)
 */
export function jsonapiIdentifier(target) {
    const { id, type } = target;
    return { id, type };
}
/**
 * Convert a linkage to pure identifiers.
 *
 * @param  {ResourceLinkage} linkage - a linkage to-one, to-many, or nullable
 * @return {?ResourceLinkage} - a linkage, converted to identifiers.
 */
export function jsonapiLinkage(linkage) {
    if (Array.isArray(linkage)) {
        return linkage.map(jsonapiIdentifier);
    }
    else if (linkage) {
        return jsonapiIdentifier(linkage);
    }
    else if (linkage === null) {
        return null;
    }
    return undefined;
}
